export default {"src":"/_next/static/media/usd.d097cf0b.svg","height":32,"width":32,"blurWidth":0,"blurHeight":0};